import { useMatchCardContext } from "PFApp/components/activity_match_card/match_card_context";
import { FillAndBookButton as WrappedFillAndBookButton } from "PFApp/components/fill_and_book_button";

import { ShortlistButtonsProps } from "./shortlist_buttons_props";

type FillAndBookButtonProps = Omit<ShortlistButtonsProps, "shortlist"> & {
  shortlist: ShortlistButtonsProps["shortlist"] | null;
};

export const FillAndBookButton = ({ shortlist }: FillAndBookButtonProps) => {
  const { role, profile, isFillDisabled } = useMatchCardContext();

  return (
    <WrappedFillAndBookButton
      profileId={profile.id}
      activity={role}
      shortlistId={shortlist?.id}
      isFillButtonDisabled={isFillDisabled}
    />
  );
};
